import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    title: String,
    text: String,
    placement: {
      type: String,
      default: "top"
    },
    delay: {
      type: Number,
      default: 120
    }
  }

  connect() {
    if (!this.textValue && !this.titleValue) return

    this.hideTimer = null
    this.tooltip = document.createElement("div")
    this.tooltip.className = "pointer-events-none fixed z-50 hidden max-w-xs rounded-md border border-slate-700 bg-slate-900 px-3 py-2 text-xs text-slate-100 shadow-lg"
    this.tooltip.innerHTML = this.tooltipContent()
    document.body.appendChild(this.tooltip)

    this.showBound = this.show.bind(this)
    this.hideBound = this.hide.bind(this)
    this.element.addEventListener("mouseenter", this.showBound)
    this.element.addEventListener("focusin", this.showBound)
    this.element.addEventListener("mouseleave", this.hideBound)
    this.element.addEventListener("focusout", this.hideBound)
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this.showBound)
    this.element.removeEventListener("focusin", this.showBound)
    this.element.removeEventListener("mouseleave", this.hideBound)
    this.element.removeEventListener("focusout", this.hideBound)

    if (this.tooltip) this.tooltip.remove()
    if (this.hideTimer) window.clearTimeout(this.hideTimer)
  }

  show() {
    if (!this.tooltip) return
    if (this.hideTimer) window.clearTimeout(this.hideTimer)

    this.tooltip.classList.remove("hidden")
    this.positionTooltip()
  }

  hide() {
    if (!this.tooltip) return

    this.hideTimer = window.setTimeout(() => {
      this.tooltip.classList.add("hidden")
    }, this.delayValue)
  }

  tooltipContent() {
    const title = this.titleValue ? `<div class="mb-1 font-semibold">${this.escape(this.titleValue)}</div>` : ""
    const text = this.textValue ? `<div>${this.escape(this.textValue)}</div>` : ""
    return `${title}${text}`
  }

  positionTooltip() {
    const anchor = this.element.getBoundingClientRect()
    const tooltip = this.tooltip.getBoundingClientRect()
    const gap = 10
    let top = anchor.top - tooltip.height - gap
    let left = anchor.left + (anchor.width / 2) - (tooltip.width / 2)

    if (this.placementValue === "bottom") top = anchor.bottom + gap
    if (this.placementValue === "left") {
      top = anchor.top + (anchor.height / 2) - (tooltip.height / 2)
      left = anchor.left - tooltip.width - gap
    }
    if (this.placementValue === "right") {
      top = anchor.top + (anchor.height / 2) - (tooltip.height / 2)
      left = anchor.right + gap
    }

    const viewportPadding = 8
    left = Math.max(viewportPadding, Math.min(left, window.innerWidth - tooltip.width - viewportPadding))
    top = Math.max(viewportPadding, Math.min(top, window.innerHeight - tooltip.height - viewportPadding))

    this.tooltip.style.top = `${top}px`
    this.tooltip.style.left = `${left}px`
  }

  escape(value) {
    return String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll("\"", "&quot;")
      .replaceAll("'", "&#39;")
  }
}
